import(/* webpackMode: "eager", webpackExports: ["ForgotForm"] */ "/app/src/modules/forgot/forgot-form/forgot-form.tsx");
